'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ThirdPartyEngagementDetail } from '@/features/ghg/components/ThirdPartyEngagementDetail';
import i18n from '@/lib/i18n';

export const Route = createFileRoute(
  '/_authenticated/ghg/third-party-verification/$engagementId'
)({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.engagementDetails'),
  }),
  component: EngagementDetailPage,
});

function EngagementDetailPage() {
  const { engagementId } = Route.useParams();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-6xl">
        <ThirdPartyEngagementDetail engagementId={engagementId} />
      </div>
    </div>
  );
}
